<style lang = 'scss' scoped>
  /deep/.ivu-modal{
    margin-bottom: 15px;
  }
  .sourceModal{
    /deep/.ivu-modal{
      /*width:450px!important;*/
    }
    .buttonDiv{
      text-align: center;
      .btn-def{
        display: inline-block;
        width: 120px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        color: #fff;
        margin: 0 7px;
        background-color: var(--baseSkyBlue);
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
      }
      .pageSpan{
        font-size: 16px;
      }
    }
  }
</style>

<template>
  <Modal
    v-model="sourceModalBoolean"
    :title="sourceModalTitle"
    :transfer='true'
    :footer-hide='true'
    @on-cancel="sourceModalClose" width='700' class='sourceModal' :mask-closable="true"
    :mydata="controlSourceType">
    <!-- 视频资源 -->
    <div v-if='sourceType == "2"'>
      <Aliplayer :source='this.sourceCovor' ref="aliplayer"></Aliplayer>
    </div>
  </Modal>
</template>

<script>
import Aliplayer from '@/components/common/Aliplayer'
import { removeAplayerButton } from '@/js/public'
import { mapState } from 'vuex'
import { } from '@/api/getApi'
export default {
  name: 'sourceModal',
  components: { Aliplayer },
  modalWidth: 450,
  data () {
    return {
      msg: '',
      abc: this.isModuled,
      // 加载进度
      loadedRatio: 0,
      curPageNum: 0
    }
  },
  props: {
    controlSourceModal: Boolean,
    sourceType: {
      type: String,
      default: '2'
    },
    sourceCovor: String
  },
  computed: {
    controlSourceType () {
      return this.sourceType
    },
    sourceModalBoolean: {
      set: function () {
      },
      get: function () {
        return this.sourceModal
      }
    },
    sourceModalTitle () {
      let title = ''
      switch (this.sourceType) {
        case '1':
          title = `显示图片资源`
          break
        case '2':
          title = `显示视频资源`
          break
        case '3':
          title = `显示音频资源`
          break
        case '4':
          title = `显示附件资源`
          break
        default:
          // console.log(title)
          break
      }
      return title
    },
    ...mapState({
      sourceModal: state => state.sourceModal
    })
  },
  // components: { vuealiplayer },
  methods: {
    // 定时删除按钮的方法
    setTimeButton () {
      if (this.$refs.aplayer) {
        removeAplayerButton(this.$refs.aplayer)
      } else {
        setTimeout(() => {
          this.setTimeButton()
        }, 100)
      }
    },
    // 更改加载的资源
    changeSouce (type, data) {
      if ((type === 2 || type === '2') && this.$refs.aliplayer) {
        this.$refs.aliplayer.getPlayauth(data || '')
      }
    },
    // 弹窗关闭的时候需要从vuex中进行操作
    sourceModalClose () {
      // 关闭弹窗时暂停播放
      if (this.$refs.aliplayer) {
        this.$refs.aliplayer.pause()
      }
      this.$store.dispatch('sourceType', 1)
      this.$emit('changeCover')
      this.$store.dispatch('sourceModal', false)
    }
  },
  beforeCreate () {
  },
  async created () {
  },
  mounted () {
  },
  watch: {
    sourceModal (newDate, old) {
      this.setTimeButton()
    }
  }
}
</script>
